import { SquatSVG } from "./SVGIllustrations";
import { TextInput } from "@/components/we360/TextInput";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { AlertBanner } from "@/components/we360/AlertBanner";

export default function Step4Squats({ value, onChange, classification, sex, isDefaultSex, errors, onBlur }) {
  return (
    <div>
      <div className="text-center mb-2">
        <SquatSVG reps={value} sex={sex} />
      </div>

      <div
        className="rounded-[14px] p-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
        data-testid="f2-squat-instructions"
      >
        Realiza tantas sentadillas correctas como puedas en <strong>30 segundos</strong>.
        Baja hasta que tus muslos esten paralelos al suelo.
      </div>

      <TextInput
        label="Repeticiones"
        value={value}
        onChange={onChange}
        onBlur={() => onBlur?.("sentadillas")}
        placeholder="15"
        suffix="reps"
        type="number"
        min="0"
        max="60"
        error={errors?.getError("sentadillas")}
        testId="input-sentadillas"
      />

      {classification && (
        <>
          <CalculatedBadge
            label="Sentadillas 30s"
            value={`${value}`}
            unit="reps"
            category={classification.label}
            categoryColor={classification.color}
            testId="badge-sentadillas"
          />
          {isDefaultSex && (
            <AlertBanner variant="info" testId="alert-default-sex-squat">
              Clasificacion usando valores de referencia generales.
            </AlertBanner>
          )}
        </>
      )}
    </div>
  );
}
